import React from "react";

export const StepShell = ({ icon: Icon, title, subtitle, children, testId }) => {
  return (
    <section className="step-fade" data-testid={testId}>
      <div className="flex items-start gap-4 mb-8">
        {Icon && (
          <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 text-primary flex items-center justify-center">
            <Icon className="w-6 h-6" strokeWidth={1.8} />
          </div>
        )}
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h2>
          {subtitle && <p className="mt-1 text-base text-slate-500 max-w-2xl leading-relaxed">{subtitle}</p>}
        </div>
      </div>
      {children}
    </section>
  );
};

export const EyeResultRow = ({ label, hint, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 py-3">
    <div className="sm:w-56 flex-shrink-0">
      <p className="text-sm font-semibold text-slate-800">{label}</p>
      {hint && <p className="text-xs text-slate-400">{hint}</p>}
    </div>
    <div className="flex-1">{children}</div>
  </div>
);
